import { useState } from 'react';

/** Uma preferência de quem olha, guardada no navegador; sem armazenamento, vale só na aba. */
export function useStoredFlag(
  key: string,
  initial: boolean,
): [boolean, (v: boolean) => void] {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored === null ? initial : stored === '1';
    } catch {
      return initial;
    }
  });
  const set = (v: boolean) => {
    setValue(v);
    try {
      localStorage.setItem(key, v ? '1' : '0');
    } catch {
      /* sem armazenamento (aba privada): fica só nesta aba */
    }
  };
  return [value, set];
}
